import { useMutation } from '@tanstack/react-query';
import { postResendOTP } from 'services';
import { useSnackbar } from 'hooks';

const errorMessage = 'Something went wrong, please try again later.';
export function usePostResendOtp() {
  const setSnackbar = useSnackbar();

  return useMutation({
    mutationFn: (payload: number) => postResendOTP(payload),
    onSuccess: () => {
      setSnackbar({
        message: 'Business contact number changed successfully!',
        severity: 'success',
      });
    },
    onError: (error) => {
      const errorResponse = error as {
        response?: { data?: { displayMessage?: string } };
      };
      setSnackbar({
        message: errorResponse?.response?.data?.displayMessage || errorMessage,
        severity: 'error',
      });
    },
  });
}
